import React, { useContext } from 'react'
import { Helmet } from 'react-helmet'
import { Controller, useForm } from 'react-hook-form'
import { PROJECT_TITLE } from '../../../util/constant'
import { yupResolver } from '@hookform/resolvers/yup'
import { forgotPasswordSchema } from '../../../util/validationSchema'
import { useNavigate } from 'react-router-dom'
import { SpinnerContext } from '../../../context/spinnerContext'
import { useDispatch } from 'react-redux'
import { forgotPassword } from '../../../redux/slices/authSlice'
import { errorToast, successToast } from '../../../util/Toast/toast'

const ForgotPassword = () => {
  const { changeLoader } = useContext(SpinnerContext)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {
    handleSubmit,
    control,
    trigger,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(forgotPasswordSchema)
  })

  const onSubmit = async (data) => {
    if (data) {
      changeLoader(true)
      dispatch(forgotPassword(data)).then(({ payload }) => {
        if (payload?.status === 200) {
          successToast(payload?.data?.status_message || 'Success!')
          changeLoader(false)
          // navigate(`/reset-password/${payload?.data?.forgotPasswordToken}`)
        } else {
          errorToast(payload?.data?.status_message || 'Something went wrong')
          changeLoader(false)
        }
      })
    }
  }

  return (
    <>
      <Helmet>
        <title>{PROJECT_TITLE}</title>
        <link rel="icon" href={''}></link>
      </Helmet>
      <div className="auth-wrapper-main">
        <div className="container ">
          <div className="authbox">
            <div className="auth-left">
              <div className="auth-page-title">Forgot Password</div>

              <p className="auth-page-sub-title">Enter your email to get a password reset link</p>

              <div className="auth-form-content">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="form-group input_text mb-5">
                    <label className="form-control-label">
                      Email<span className="text-danger"> *</span>
                    </label>
                    <Controller
                      name="email"
                      control={control}
                      render={({ field: { value, onChange }, fieldState }) => (
                        <>
                          <input
                            className={`form-control  ${errors?.email ? 'error-input' : ''}`}
                            type="text"
                            value={value || ''}
                            autoComplete="false"
                            placeholder="Enter Email Address"
                            onChange={(val) => {
                              onChange(val)
                              trigger('email')
                            }}
                          />
                          <small>{fieldState?.error?.message}</small>
                        </>
                      )}
                    />
                  </div>

                  <div className="form-group mb-3">
                    <button className="btn btn-lg btn-block w-100 btn-primary" type="submit">
                      Sent
                    </button>
                  </div>
                  <div className="form-group mb-3">
                    <button className="btn common-outline-btn w-100" type="button" onClick={() => navigate('/login')}>
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
            {/* <div className="auth-right auth-forgot-pwd-bg-img"></div> */}
          </div>
        </div>
      </div>
    </>
  )
}

export default ForgotPassword
